import { showError } from "@/modules/error/errorStream.ts";
import type { ZodType } from "zod";

export function safeParseAndLog<TOutput>(
    schema: ZodType<TOutput, any, any>,
    value: unknown,
    fallback: NoInfer<TOutput>,
    message = "Error parsing schema",
): TOutput {
    const result = schema.safeParse(value);
    if (!result.success) {
        showError(`${message}:`, result.error);
        return fallback;
    }
    return result.data;
}
